import type { ClusterBandDefinition, OverallBandDefinition } from '../../data/schemas';

/**
 * Bestimmt das Gesamtband primär über den Punktwert (Abschnitt 15.2).
 * Der Prozentwert dient nur als Anzeige/Plausibilitätsprüfung.
 */
export function determineOverallBand(
  score: number,
  bands: OverallBandDefinition[],
): OverallBandDefinition {
  const match = bands.find((band) => score >= band.minimumScore && score <= band.maximumScore);
  if (!match) {
    throw new Error(`Kein Gesamtband für Score ${score} gefunden.`);
  }
  return match;
}

export function determineClusterBand(
  percentage: number,
  bands: ClusterBandDefinition[],
): ClusterBandDefinition {
  const match = bands.find(
    (band) => percentage >= band.minimumPercentage && percentage <= band.maximumPercentage,
  );
  if (!match) {
    throw new Error(`Kein Cluster-Band für Prozentwert ${percentage} gefunden.`);
  }
  return match;
}
